export var AlertVariant = /*#__PURE__*/ function(AlertVariant) {
    AlertVariant["default"] = "default";
    AlertVariant["brand"] = "brand";
    AlertVariant["gray"] = "gray";
    AlertVariant["warning"] = "warning";
    AlertVariant["error"] = "error";
    AlertVariant["success"] = "success";
    AlertVariant["info"] = "info";
    return AlertVariant;
}({});
